import { SelectOption } from "../common/components/form/Select";

export const CurrencyOptions: SelectOption[] = [
    {
        value: "SGD",
        label: "SGD",
    },
    {
        value: "USD",
        label: "USD",
    },
    {
        value: "CNY",
        label: "CNY",
    },
];
